import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUnvollstaendigeBewertungen = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "34px",
	height: "34px",
	viewBox: "0 0 34 34",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Material-Design-Stickersheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "After-Login-Welcome-Screen",
			transform: "translate(-8.000000, -231.000000)",
			fill: "#FFFFFF",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group",
				transform: "translate(8.000000, 231.000000)",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Group-5-Copy",
					fillRule: "nonzero",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "add",
						children: [
							/* @__PURE__ */ _jsx("path", {
								d: "M24.5,34 C19.2618462,34 15,29.7381538 15,24.5 C15,19.2618462 19.2618462,15 24.5,15 C29.7381538,15 34,19.2618462 34,24.5 C34,29.7381538 29.7381538,34 24.5,34 Z M24.5,17.1923077 C20.4705385,17.1923077 17.1923077,20.4705385 17.1923077,24.5 C17.1923077,28.5294615 20.4705385,31.8076923 24.5,31.8076923 C28.5294615,31.8076923 31.8076923,28.5294615 31.8076923,24.5 C31.8076923,20.4705385 28.5294615,17.1923077 24.5,17.1923077 Z",
								id: "Shape"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M12.9741176,30 L3.88235294,30 C1.74070588,30 0,28.2385714 0,26.0714286 L0,3.92857143 C0,1.76142857 1.74070588,0 3.88235294,0 L20.1176471,0 C22.2592941,0 24,1.76142857 24,3.92857143 L24,12.6285714 C24,13.22 23.5256471,13.7 22.9411765,13.7 C22.3567059,13.7 21.8823529,13.22 21.8823529,12.6285714 L21.8823529,3.92857143 C21.8823529,2.94428571 21.0903529,2.14285714 20.1176471,2.14285714 L3.88235294,2.14285714 C2.90964706,2.14285714 2.11764706,2.94428571 2.11764706,3.92857143 L2.11764706,26.0714286 C2.11764706,27.0557143 2.90964706,27.8571429 3.88235294,27.8571429 L12.9741176,27.8571429 C13.5585882,27.8571429 14.0329412,28.3371429 14.0329412,28.9285714 C14.0329412,29.52 13.5585882,30 12.9741176,30 Z",
								id: "Path"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M17.9772727,14 L5.02272727,14 C4.45818182,14 4,13.552 4,13 C4,12.448 4.45818182,12 5.02272727,12 L17.9772727,12 C18.5418182,12 19,12.448 19,13 C19,13.552 18.5418182,14 17.9772727,14 Z",
								id: "Path"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M12.9285714,19 L5.07142857,19 C4.48,19 4,18.552 4,18 C4,17.448 4.48,17 5.07142857,17 L12.9285714,17 C13.52,17 14,17.448 14,18 C14,18.552 13.52,19 12.9285714,19 Z",
								id: "Path"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M11.875,8 L5.125,8 C4.504,8 4,7.552 4,7 C4,6.448 4.504,6 5.125,6 L11.875,6 C12.496,6 13,6.448 13,7 C13,7.552 12.496,8 11.875,8 Z",
								id: "Path"
							})
						]
					})
				}), /* @__PURE__ */ _jsx("text", {
					id: "?",
					fontFamily: "RalewayRoman-Black, Raleway",
					fontSize: 15,
					fontWeight: 800,
					letterSpacing: .18561183,
					children: /* @__PURE__ */ _jsx("tspan", {
						x: 21.3893882,
						y: 30,
						children: "?"
					})
				})]
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgIconUnvollstaendigeBewertungen);
export { ForwardRef as ReactComponent };
